'use client';

import React, { useState, useEffect } from 'react';
import { Card } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Switch } from '../../../components/ui/switch';
import { Grid2x2Plus } from 'lucide-react';

interface LimitedPlacesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (limitedPlaces: string, waitingList: boolean) => void;
  initialPlaces?: string;
  initialWaitingList?: boolean;
}

export const LimitedPlacesModal: React.FC<LimitedPlacesModalProps> = ({
  isOpen,
  onClose,
  onSave,
  initialPlaces = '',
  initialWaitingList = true
}) => {
  const [places, setPlaces] = useState(initialPlaces);
  const [waitingList, setWaitingList] = useState(initialWaitingList);

  useEffect(() => {
    if (isOpen) {
      setPlaces(initialPlaces);
      setWaitingList(initialWaitingList);
    }
  }, [isOpen, initialPlaces, initialWaitingList]);

  const handleSave = () => {
    onSave(places, waitingList);
    onClose();
  };

  const handleCancel = () => {
    setPlaces(initialPlaces);
    setWaitingList(initialWaitingList);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 overflow-x-hidden bg-black/60 flex items-center justify-center z-50">
      <Card className="w-full sm:max-w-md mx-0 sm:mx-4 p-4 sm:p-6">
        <div className="mb-4">
          <div className="w-10 h-10">
            <Grid2x2Plus className="w-6 h-6" />
          </div>
          <h2 className="text-xl font-semibold">Limited places</h2>
        </div>

        <p className="text-gray-800 mb-6">
          Automatically close registration when the quota is reached.
          Only approved guests count toward the limit.
        </p>

        <div className="mb-6">
          <Input
            type="number"
            placeholder="50"
            value={places}
            onChange={(e) => setPlaces(e.target.value)}
            className="text-lg mb-4"
            min="1"
            max="10000"
          />
          
          <div className="flex items-center mt-4 bg-gray-50 rounded-lg">
            <Switch
              checked={waitingList}
              onCheckedChange={setWaitingList}
              checkedColor='bg-green-600 m-0'
            />
            <span className="text-gray-800 ml-4 text-xs">
              Waiting list due to overcrowding
            </span>
            
          </div>
        </div>

        <div className="space-y-3">
          <Button 
            onClick={handleSave}
            className="w-full bg-accent text-white hover:bg-accent/90"
          >
            Save
          </Button>
          
          <Button 
            onClick={handleCancel}
            variant="outline"
            className="w-full"
          >
            Cancel
          </Button>
        </div>
      </Card>
    </div>
  );
};